jQuery( $ => {
	$( '[data-search-toggle]' ).on( 'click', function() {
		$( this ).toggleClass( 'search-open' );

		$( this ).attr( 'aria-expanded', ( i, attr ) => {
			return 'true' === attr ? 'false' : 'true';
		} );

		$( '#search-container' ).slideToggle( 150, function() {
			$( this ).find( '.form-control' ).focus();
		} );
	} );
} );
